export function defineMachine() {
  return function (definition) {
    return definition;
  };
}